import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Paper, Grid } from '@material-ui/core';
// import { } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}
const EditForm = (props) => {
    const { currentUser } = props;
    const [user, setUser] = useState(currentUser);

    useEffect(() => {
        setUser(currentUser);
    }, [props]);

    const handleInputChange = (event) => {
        //console.log(typeof event.target.value)

        const { name, value } = event.target;

        setUser({ ...user, [name]: value });
    };

    const str2bool = (value) => {
        if (value && typeof value === 'string') {
            if (value.toLowerCase() === 'true') return true;
            if (value.toLowerCase() === 'false') return false;
        }
        return value;
    };
    const handleRadioChange = (e) => {
        const tf = str2bool(e.target.value);
        const { name } = e.target;
        setUser({ ...user, [name]: tf });
    };

    return (
        <Paper>
            <div className="main-container">
                <Grid item xs={12} sm={12}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="enter-question" shrink>
                            Update Question
                        </InputLabel>
                        <Input
                            className="bottomLine"
                            type="text"
                            name="questionText"
                            value={user.questionText}
                            onChange={handleInputChange}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormControl fullWidth>
                        <Typography variant="subtitle1" gutterBottom>
                            Attachment Required
                        </Typography>
                        <div>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    aria-label="attachment"
                                    name="isAttachmentRequired"
                                    value={user.isAttachmentRequired ? 'true' : 'false'}
                                    onChange={handleRadioChange}
                                    className="radio-option"
                                >
                                    <ul className="makeStyles-inlineDisplay-111">
                                        <li>
                                            <FormControlLabel value="true" control={<StyledRadio />} label="Yes" />
                                            {/* <FormControlLabel value="Yes" control={<StyledRadio />} label="Yes" /> */}
                                        </li>
                                        <li>
                                            <FormControlLabel value="false" control={<StyledRadio />} label="No" />
                                            {/* <FormControlLabel value="No" control={<StyledRadio />} label="No" /> */}
                                        </li>
                                    </ul>
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div className="add-button">
                        <Button
                            color="primary"
                            onClick={() => {
                                props.setEditing(false);
                                props.updateUser(user.questionId, user);
                                //console.log("update", user);
                            }}
                        >
                            Update
                        </Button>
                        <Button
                            color="primary"
                            onClick={() => {
                                props.setEditing(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </Grid>
            </div>
        </Paper>
    );
};

export default EditForm;
